let base_url = process.env.REACT_APP_YANKEE_API_URL || "http://127.0.0.1:8000";

export default base_url;
